var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.666 25.0003C15.666 20.6006 15.666 18.4007 17.0329 17.0338C18.3997 15.667 20.5996 15.667 24.9993 15.667C29.3991 15.667 31.599 15.667 32.9658 17.0338C34.3327 18.4007 34.3327 20.6006 34.3327 25.0003C34.3327 29.4001 34.3327 31.6 32.9658 32.9668C31.599 34.3337 29.3991 34.3337 24.9993 34.3337C20.5996 34.3337 18.3997 34.3337 17.0329 32.9668C15.666 31.6 15.666 29.4001 15.666 25.0003ZM29.666 26.167C29.9578 26.167 30.219 26.348 30.3214 26.6212C30.4239 26.8944 30.3461 27.2025 30.1263 27.3944L26.918 30.1944C26.6267 30.4486 26.1845 30.4185 25.9303 30.1273C25.6761 29.836 25.7061 29.3938 25.9974 29.1396L27.7993 27.567L20.3327 27.567C19.9461 27.567 19.6327 27.2536 19.6327 26.867C19.6327 26.4804 19.9461 26.167 20.3327 26.167L29.666 26.167ZM24.0684 19.8734C24.3226 20.1647 24.2926 20.6069 24.0013 20.8611L22.1993 22.4337H29.666C30.0526 22.4337 30.366 22.7471 30.366 23.1337C30.366 23.5203 30.0526 23.8337 29.666 23.8337H20.3327C20.0409 23.8337 19.7797 23.6527 19.6773 23.3794C19.5748 23.1062 19.6526 22.7981 19.8724 22.6063L23.0807 19.8063C23.372 19.5521 23.8142 19.5821 24.0684 19.8734Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transferIcon.bb9636f40951bafe70cf0135d7d0bc18.svg";
export { ForwardRef as ReactComponent };